<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog persistent v-model="$auth.customerSelectPopup" width="auto " :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="text-center justify-center py-6">
        <div class="text-h6 text-sm-h4">{{ language.t('CustomerSelect.selectCustomer') }}</div>
      </v-card-title>
      <v-card-text class="text-center justify-center py-6">
        <v-alert v-if="$auth.customerSelectError != false" dense border="left" type="warning">{{ getError() }}
        </v-alert>
        <v-alert v-if="noCustomersError" type="warning" dense>dit account is niet gekoppeld aan een klant</v-alert>
        <v-autocomplete ref="customerselect" v-model="selection" :loading="loading" :items="items"
          :search-input.sync="search" cache-items hide-no-data filled label="" item-text="name" item-value="id"
          :label="language.t('CustomerSelect.searchCustomer')">
        </v-autocomplete>
      </v-card-text>
      <v-card-actions v-if="customerId || noCustomersError" class="card-actions">
        <v-btn color="blue darken-1" text @click="logout();" v-if="noCustomersError">{{ language.t("Menu.logout")
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onClose();" v-if="customerId">
          <v-icon>mdi-close</v-icon>{{ language.t('App.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      selection: null,

      noCustomersError: false,
      searchQuery: null,
      timeout: null,
      requestCancelToken: null,
    };
  },
  computed: {
    customerSelectPopup() {
      return this.$auth.customerSelectPopup;
    },
    customerId() {
      return this.$auth.customerId;
    },
  },
  watch: {
    customerSelectPopup(val) {
      if (val) {
        this.selection = null;
        this.items = [];
        if (this.$refs.customerselect) this.$refs.customerselect.cachedItems = [];
      }
    },
    selection(val) {
      if (val) this.$auth.setCustomer(val);
    },
    search(val) {
      val && !this.selection && this.querySelections(val)
    },
  },
  methods: {
    querySelections(v) {
      this.searchQuery = '?q=' + v;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.loading = true;
        if (!this.selection)
          this.$axios.get(route('api.auth.searchcustomer') + this.searchQuery)
            .then((response) => {
              this.items = response.data;
              console.log(response);
              this.loading = false;
            })
            .catch((error) => {
              console.log(error);
              this.loading = false;
            });
          else console.log("already selected")
      }, 250);
    },
    getCustomers() {
      console.log("Get customer list");
      this.loading = true;
      this.items = [];
      // TODO: this route should return a correct array that we can use directly
      this.$axios.get(route("api.user.customers")).then((res) => {
        console.log(res);
        for (let i = 0; i < res.data.length; i++) {
          this.items.push({ id: res.data[i].customerId, name: res.data[i].name });
        }
        if (this.items.length < 1) {
          this.noCustomersError = true;
        }
        this.loading = false;
      });
    },
    getError() {
      if (this.$auth.customerSelectError.code == "NO_SUBSCRIPTION") return "This customer has no subscription";
      return "Could not select customer, try again or contact support.";
    },
    onClose() {
      this.$auth.customerSelectPopup = false;
      this.$auth.customerSelectError = false;
    },
    logout() {
      this.$auth.logout();
    },
  },
};
</script>
